module.exports = __webpack_public_path__ + "img/ldcs.dd29b95d.svg";